// Stagehook Global — brand mark (uses uploaded PNG/JPG logo from /public)
const StagehookLogo = ({ size = 40, radius = 6, className = "" }) => (
  <img
    src="/logo.jpg"
    alt="Stagehook Global"
    width={size}
    height={size}
    className={className}
    style={{
      width: size,
      height: size,
      borderRadius: radius,
      objectFit: "cover",
      display: "block",
    }}
  />
);

export default StagehookLogo;
